import compose from 'ramda/src/compose';
import toLower from 'ramda/src/toLower';
import prop from 'ramda/src/prop';
import sortBy from 'ramda/src/sortBy';

import { isFalsy } from 'lib/Helpers';

/**
 * Sort Collection by Property Key in Ascending Order
 * @param {Array.<Object>} data - Collection to be Sorted
 * @param {String} propName - Property Key
 * @return {Array.<Object>} - Sorted Collection
 */
const sortByPropAscendingCaseInsensitive = (data, propName) => {
  if (isFalsy(data) || isFalsy(propName)) return [];
  return sortBy(compose(toLower, prop(propName)))(data);
};

export default sortByPropAscendingCaseInsensitive;
